import { Outlet } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { useSite } from "@/lib/site";
import { waLink } from "@/lib/api";

export default function PublicLayout() {
  const { settings } = useSite();
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 pt-20"><Outlet /></main>
      <Footer />
      {settings.whatsapp && (
        <a href={waLink(settings.whatsapp, "Hola SoloRentaPC, busco una propiedad en alquiler de largo plazo.")} target="_blank" rel="noreferrer"
          className="fixed bottom-6 right-6 z-40 h-14 w-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-xl hover:scale-105 transition-transform" data-testid="floating-whatsapp" aria-label="WhatsApp">
          <MessageCircle size={26} />
        </a>
      )}
    </div>
  );
}
